// src/services/CountryService.js
import api from "./api";

export function getDuration(page = 1, limit = 10, search = "") {
    return api.get(`/duration?page=${page}&limit=${limit}&search=${search}`);
}

export function getDurationById(id) {
    return api.get(`/duration/${id}`);
}

export function addDuration(data) {
    return api.post("/duration", data);
}

export function updateDuration(id, data) {
    return api.put(`/duration/${id}`, data);
}

export function deleteDuration(id) {
    return api.delete(`/duration/${id}`);
}
